<ion-card class="post">
  <swiper-container pagination="true" [zoom]="true" #swiper>
    <swiper-slide *ngFor="let image of casee.images"><img [src]="image.url" style="width: 100%"
        *ngIf="image.url" /></swiper-slide>
  </swiper-container>
  <ion-text>
    <div class="footer">
      <span class="username" (click)="openUserOptions(casee.userid, casee.username)">&#64;{{ casee.username }}</span>
      <span class="date">{{ formatDate(casee.createdDate) }}</span>
    </div>
  </ion-text>
  <ion-card-title class="solved" *ngIf="hideDelete && casee.isClosed">
    Solved
  </ion-card-title>
  <ion-card-title class="type">{{ caseType }} </ion-card-title>
  <ion-card-subtitle class="location">{{ casee.location }}</ion-card-subtitle>
  <ion-card-content class="info">{{ casee.details }}</ion-card-content>
  <div class="interact">
    <ion-button fill="clear" color="darkmimbo" (click)="ViewComments(casee.id, casee.userid)">
      <ion-icon name="chatbubble-outline"></ion-icon>
      <ion-text>{{ casee.commentsCount }} </ion-text>
    </ion-button>

    <ion-button class="options" fill="clear" (click)="presentActionSheet(casee)">
      <ion-icon name="ellipsis-vertical-outline" slot="icon-only"></ion-icon></ion-button>
  </div>

  <ion-button expand="full" fill="clear" color="primary" (click)="viewDetails(casee.id)" size="small"><ion-icon
      name="eye-outline" slot="start"></ion-icon>View
    Details</ion-button>
</ion-card>
<div class="line-break"></div>